"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNonEmptyString = void 0;

var isNonEmptyString = function isNonEmptyString(value) {
  return !!value && typeof value === 'string';
};

exports.isNonEmptyString = isNonEmptyString;